import React from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
// import Grid from '@material-ui/core/Grid';
import Helmet from 'react-helmet';

// import { Button } from '@material-ui/core';
import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';

// import Hero from '../../static/img/sales/hero.png';
import Hero from '../../static/img/sales/black_friday_2022/nia_black_friday_hero.gif';
// import UpTo150Off from '../../static/img/sales/black_friday_2022/up_to_150_off_trainings.png';
// import OneFiftyOff from '../../static/img/sales/black_friday_2022/150_off_body_life_resized.png';
// import OneHundredOff from '../../static/img/sales/black_friday_2022/100_off_greenbelt_resized.png';
// import FiftyOff from '../../static/img/sales/black_friday_2022/75_off_specialty_trainings_resized.png';
// import VideoLink from '../../static/img/sales/black_friday_2022/nia_black_friday_howto.png';
// import WhitebeltPromo from '../../static/img/sales/black_friday_2022/nia_whitebelt_promo.gif';
// import UnwrapOffer from '../../static/img/sales/black_friday_2022/unwrap_special_offer.gif';
// import NiaFounderOffer from '../../static/img/sales/black_friday_2022/nia_founder_offer.png';
// import NiaOnDemandSale from '../../static/img/sales/black_friday_2022/nia_on_demand_sale.gif';
// import DontWaitSale from '../../static/img/sales/black_friday_2022/nia_dont_wait_2022.png';

// import MemorialDaySaleBanner from '../../static/img/sales/memorial_day_2024/memorial_day_2024_banner.jpg';
// import MemorialDayCallToAction from '../../static/img/sales/memorial_day_2024/redeem_your_offer.png';
// import memorialDaySale2024Data from '../../static/memorial_day_sale_2024_data';

const Grey = '#A1B2B0';
const Red = '#F63C57';
const lightRed = '#7B1E2C';


const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'white',
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(4),
  },
  hero: {
    height: 'auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  heroImg: {
    height: 'auto',
    width: '100%',
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  section: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  sectionNoPadding: {
    paddingTop: 'none',
    paddingBottom: 'none',
  },
  headerText: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    letterSpacing: 3,
    fontWeight: 200,
    [theme.breakpoints.down(600)]: {
      fontSize: '40px',
    },
    fontSize: '48px',
    color: 'black',
  },
  headerSubText: {
    textAlign: 'center',
    letterSpacing: 2,
    // fontWeight: 100,
    [theme.breakpoints.down(600)]: {
      fontSize: '24px',
    },
    textTransform: 'uppercase',
    // color: Gold,
    color: Grey,
  },
  subText: {
    // fontSize: '20px',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    color: Grey,
    fontStyle: 'italic',
  },
  sectionImg: {
    width: '80%',
    height: 'auto',
    marginBottom: theme.spacing(3),
  },
  sectionText: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
  couponCode: {
    color: Grey,
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(2),
  },
  button: {
    color: 'white',
    backgroundColor: Red,
    '&:hover': {
      backgroundColor: lightRed,
    },
  },
  textContainer: {
    padding: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // alignItems: 'center',
  },
  imgContainer: {
    padding: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
  },
  sectionImgContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  marginTop: {
    marginTop: theme.spacing(5),
  },
  marginBottom: {
    marginBottom: theme.spacing(5),
  },
  buttonLeft: {
    marginBottom: theme.spacing(),
    [theme.breakpoints.up(430)]: {
      marginRight: theme.spacing(),
      marginBottom: 0,
    },
  },
  buttonRight: {
    marginTop: theme.spacing(),
    [theme.breakpoints.up(430)]: {
      marginLeft: theme.spacing(),
      marginTop: 0,
    },
  },
  videoLinkContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  videoLinkImg: {
    height: 'auto',
    width: '100%',
  },
  videoLink: {
    width: '80%',
  },
  bold: {
    fontWeight: 'bold',
  },
  buttonContainerCenter: {
    textAlign: 'center',
    padding: theme.spacing(4),
  },
});

const Template = (props) => {
  const { classes } = props;
  return (
    <div className={classes.page}>
      <Helmet>
        <title>Nia Black Friday Holiday Sale</title>
        <meta name="description" content="Save big on 2023 Nia Trainings and get 50% off a year of Nia On Demand. Sale ends soon. Don’t wait!" />
        <meta name="keywords" content="nia, black, friday, holiday, sale" />
      </Helmet>
      <NavBar />
      <main className={classes.container}>
        <div className={classes.appBarSpacer} />
        <div className={classes.content}>
          <div className={classes.hero}>
            <img className={classes.heroImg} alt="Black friday 4 day sale" src={Hero} />
          </div>
          <div className={classes.section}>
            <Typography className={classes.headerText} color="textSecondary" variant="h3">Thank you to all of those who participated in the sale!</Typography>
            <Typography className={classes.headerSubText} color="textSecondary" variant="h5">Check back next year!</Typography>
          </div>

          {/* <div className={classes.section}>
            <Typography className={classes.headerText} color="textSecondary" variant="h3">Sale Ends November 28</Typography>
            <Typography className={classes.headerSubText} color="textSecondary" variant="h5">Register now to lock in savings</Typography>
          </div>
          <div className={classes.hero}>
            <img className={classes.heroImg} alt="Up to $150 off Nia trainings" src={UpTo150Off} />
          </div>
          <Grid container className={classes.marginTop}>
            <Grid item xs={12} sm={6} className={classes.imgContainer}>
              <img src={OneFiftyOff} className={classes.sectionImg} alt="$150 off belt trainings" />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.textContainer}>
              <Typography className={classes.sectionText}>
                <span className={classes.bold}>Take $150 off* all 2023 WHITE, BLUE, BROWN, BLACK BELT trainings. </span>
                Not sure which training you want? No worries!
                <span className={classes.bold}> Pay now and choose your training later!</span>
              </Typography>
              <Typography className={classes.couponCode}>Use Coupon Code: SAVE150BELTS</Typography>
              <div className={classes.buttonContainer}>
                <Button size="small" variant="outlined" className={classNames(classes.buttonLeft, classes.button)} href="/finder/training">Find your Training</Button>
                <Button size="small" variant="outlined" className={classNames(classes.buttonRight, classes.button)} href="/shop/product/152">Buy Now Choose Later</Button>
              </div>
            </Grid>
          </Grid>
          <Grid container direction="row-reverse">
            <Grid item xs={12} sm={6} className={classes.imgContainer}>
              <img src={OneHundredOff} className={classes.sectionImg} alt="$150 off green belt trainings" />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.textContainer}>
              <Typography className={classes.sectionText}>
                <span className={classes.bold}>Take $100 off* on all 2023 GREEN BELT trainings. </span>
                Discover the ART OF TEACHING to start teaching Nia or take your teaching to the next level.
              </Typography>
              <Typography className={classes.couponCode}>Use Coupon Code: SAVE100GREEN</Typography>
              <div className={classes.buttonContainer}>
                <Button size="small" variant="outlined" className={classes.button} href="/finder/training/?type=Green%20Belt">Find your Training</Button>
              </div>
            </Grid>
          </Grid>
          <Grid container className={classes.marginBottom}>
            <Grid item xs={12} sm={6} className={classes.imgContainer}>
              <img src={FiftyOff} className={classes.sectionImg} alt="$50 off specialty trainings" />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.textContainer}>
              <Typography className={classes.sectionText}>
                <span className={classes.bold}>Take $75 off* of all 2023 Nia Specialty Trainings </span>
                including MOVING TO HEAL, FLOORPLAY, FREEDANCE, 5 STAGES, and MOVE IT programs.
              </Typography>
              <Typography className={classes.couponCode}>Use Coupon Code: SAVE75SPECIALTY</Typography>
              <div className={classes.buttonContainer}>
                <Button size="small" variant="outlined" className={classes.button} href="/finder/training/?type=Moving%20To%20Heal">Find your Training</Button>
              </div>
            </Grid>
          </Grid>
          <div className={classes.section}>
            <Typography align="center" className={classes.subText}>*Sale may not be combined with other discounts or promotions. Sale prices only valid on new 2023 training registrations made between November 14 and November 28, 2022. Discounts may not be applied to past purchases.</Typography>
          </div>
          <div className={classes.section}>
            <div className={classes.videoLinkContainer}>
              <a href="https://youtu.be/vxGeCXav6Zs" target="_blank" rel="noopener noreferrer" className={classes.videoLink}>
                <img alt="Sale Page Hero" className={classes.videoLinkImg} src={VideoLink} />
              </a>
            </div>
          </div>
          <div className={classes.sectionNoPadding}>
            <img className={classes.heroImg} alt="Unwrap Special Offer" src={UnwrapOffer} />
          </div>
          <div className={classes.sectionNoPadding}>
            <a target="_blank" rel="noreferrer noopener" className={classes.buttonLeft} href="https://onlinetraining.nianow.com/courses/nia-white-belt-with-debbie-rosas-01-20-23 ">
              <img className={classes.heroImg} alt="Nia Whitebelt Promo" src={WhitebeltPromo} />
            </a>
          </div>
          <div className={classes.section}>
            <img className={classes.heroImg} alt="Nia Founder Offer" src={NiaFounderOffer} />
            <Typography className={classes.subText} align="center">*After you register for your advanced training using Black Friday savings, you will be automatically emailed a code for $99 ART OF SENSATION access.</Typography>
            <Typography className={classes.subText} align="center">$99 access provided for first-time training registrations only.</Typography>
            <Typography className={classes.subText} align="center">(not applicable for retake registrations).</Typography>
            <div className={classes.buttonContainerCenter}>
              <Button size="large" variant="outlined" target="_blank" rel="noreferer noopener" className={classNames(classes.buttonLeft, classes.button)} href="https://onlinetraining.nianow.com/courses/nia-white-belt-with-debbie-rosas-01-20-23 ">Learn more about art of sensation</Button>
              <Button size="large" variant="outlined" className={classNames(classes.buttonRight, classes.button)} href="/finder/training">Find your Advanced Training</Button>
            </div>
          </div>
          <div className={classes.section}>
            <a href="https://niaondemand.com/" target="_blank" rel="noopener noreferrer">
              <img className={classes.heroImg} alt="Nia On Demand Sale" src={NiaOnDemandSale} />
            </a>
            <Typography className={classes.subText} align="center">*Free trial for first time on demand subscribers. 50% annual pre-paid subscription. Sale ends Novemeber 28, 2022.</Typography>
          </div>
          <div className={classes.section}>
            <img className={classes.heroImg} alt="Nia On Demand Sale" src={DontWaitSale} />
          </div> */}
        </div>
        <FooterSpacer />
      </main>
      <Footer />
    </div>
  );
};

Template.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Template);

// Memorial Day 2024 Sale Page
// const memorialDay2024SalePagestyles = theme => ({
//   appBarSpacer: theme.mixins.toolbar,
//   page: {
//     position: 'relative',
//     width: '100%',
//     minHeight: '100vh',
//     backgroundColor: 'white',
//   },
//   header: {
//     color: Red,
//     fontSize: '2.5rem',
//     marginTop: theme.spacing(4),
//     [theme.breakpoints.down(500)]: {
//       fontSize: theme.typography.pxToRem(30),
//     },
//   },
//   hero: {
//     height: 'auto',
//     width: '100%',
//     display: 'flex',
//     alignItems: 'center',
//     flexDirection: 'column',
//   },
//   heroImg: {
//     height: 'auto',
//     width: '100%',
//   },
//   p: {
//     marginTop: theme.spacing(3),
//   },
//   steps: {
//     marginTop: theme.spacing(2),
//   },
//   link: {
//     textDecoration: 'none',
//     color: 'blue',
//     '&:hover': {
//       textDecoration: 'underline',
//     },
//   },
//   container: {
//     width: 'auto',
//     marginLeft: theme.spacing(2),
//     marginRight: theme.spacing(2),
//     [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
//       width: 800,
//       marginLeft: 'auto',
//       marginRight: 'auto',
//     },
//   },
//   subText: {
//     paddingLeft: theme.spacing(4),
//     paddingRight: theme.spacing(4),
//     color: Grey,
//     fontStyle: 'italic',
//     textAlign: 'center',
//     marginBottom: theme.spacing(5),
//   },
//   sectionImg: {
//     width: '80%',
//     height: 'auto',
//     marginBottom: theme.spacing(3),
//     [theme.breakpoints.down(500)]: {
//       width: '100%',
//     },
//   },
//   sectionText: {
//     paddingTop: theme.spacing(),
//     paddingBottom: theme.spacing(),
//   },
//   couponCode: {
//     color: Grey,
//     paddingTop: theme.spacing(),
//     paddingBottom: theme.spacing(2),
//   },
//   button: {
//     color: 'white',
//     backgroundColor: Red,
//     '&:hover': {
//       backgroundColor: lightRed,
//     },
//   },
//   textContainer: {
//     padding: theme.spacing(),
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     // alignItems: 'center',
//   },
//   imgContainer: {
//     padding: theme.spacing(),
//     display: 'flex',
//     flexDirection: 'column',
//     // justifyContent: 'center',
//     alignItems: 'center',
//   },
//   sectionImgContainer: {
//     display: 'flex',
//     justifyContent: 'center',
//     marginTop: theme.spacing(5),
//   },
//   marginTop: {
//     marginTop: theme.spacing(5),
//   },
//   marginBottom: {
//     marginBottom: theme.spacing(5),
//   },
//   buttonLeft: {
//     marginBottom: theme.spacing(),
//     [theme.breakpoints.up(430)]: {
//       marginRight: theme.spacing(),
//       marginBottom: 0,
//     },
//   },
//   buttonRight: {
//     marginTop: theme.spacing(),
//     [theme.breakpoints.up(430)]: {
//       marginLeft: theme.spacing(),
//       marginTop: 0,
//     },
//   },
//   videoLinkContainer: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   videoLinkImg: {
//     height: 'auto',
//     width: '100%',
//   },
//   bold: {
//     fontWeight: 'bold',
//   },
//   buttonContainerCenter: {
//     textAlign: 'center',
//     padding: theme.spacing(4),
//   },
//   callToAction: {
//     textAlign: 'center',
//     fontWeight: 'bold',
//   },
// });

// const MemorialDay2024SalePage = (props) => {
//   const { classes } = props;
//   return (
//     <div className={classes.page}>
//       <Helmet>
//         <title>Nia Memorial Day Rememberance Event</title>
//         <meta name="description" content="Offering Nia On Demand free to families of fallen heroes." />
//         <meta name="keywords" content="nia, memorial, day, remembrance, offer" />
//       </Helmet>
//       <NavBar />
//       <main className={classes.container}>
//         <div className={classes.appBarSpacer} />
//         <div className={classes.content}>
//           <div className={classes.hero}>
//             <img className={classes.heroImg} alt="Memorial day, remember and honor" src={MemorialDaySaleBanner} />
//           </div>
//           <div className={classes.section}>
//             <Typography className={classes.p} variant="h6" color="secondary">
//               <span className={classes.header}>{memorialDaySale2024Data.header}</span>
//               <span>{memorialDaySale2024Data.copy}</span>
//               <a className={classes.link} href="https://niaondemand.com/" target="_blank" rel="noopener noreferrer">Nia On Demand</a>
//               <span>. </span>
//               <span>{memorialDaySale2024Data.copy3}</span>
//             </Typography>
//             <Typography className={classes.p} variant="h6" color="secondary">
//               <span>{memorialDaySale2024Data.copy4}</span>
//             </Typography>
//             <div className={classes.sectionImgContainer}>
//               <img className={classes.sectionImg} alt="Redeem your offer" src={MemorialDayCallToAction} />
//             </div>
//             <Typography className={classes.callToAction} variant="body1" color="secondary">
//               {memorialDaySale2024Data.callToAction}
//             </Typography>
//             <Typography className={classes.steps} variant="h6">
//               <span className={classes.bold}>Step 1: </span>
//               <span>{memorialDaySale2024Data.steps[0]}</span>
//               <a className={classes.link} href={memorialDaySale2024Data.verifyPassLink}> Verify Pass</a>
//               <span>.</span>
//             </Typography>
//             <Typography className={classes.steps} variant="h6">
//               <span className={classes.bold}>Step 2: </span>
//               <span>{memorialDaySale2024Data.steps[1]}</span>
//             </Typography>
//             <div className={classes.buttonContainerCenter}>
//               <Button size="large" variant="outlined" className={classes.button} href={memorialDaySale2024Data.verifyPassLink}>{memorialDaySale2024Data.button}</Button>
//             </div>
//             <Typography className={classes.subText} variant="body1" color="secondary">
//               {memorialDaySale2024Data.conditions}
//             </Typography>
//           </div>
//         </div>
//         <FooterSpacer />
//       </main>
//       <Footer />
//     </div>
//   );
// };

// MemorialDay2024SalePage.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

// export default withStyles(memorialDay2024SalePagestyles)(MemorialDay2024SalePage);
